import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "rebass/styled-components";
import image from "../img/prizes-hero@1x.jpg";
import image2x from "../img/prizes-hero@2x.jpg";
import Copy from "./Copy";
import Hero from "./Hero";
import { Main, Wrapper } from "./Layout";

const Prizes: React.FC = () => {
  const { t } = useTranslation("prizes");
  return (
    <Wrapper>
      <Main>
        <Hero
          title={t("prizes.title", "Prizes")}
          image={image}
          image2x={image2x}
        />
        <Copy>
          <Box my="6em">
            <Box my="2rem">
              <h3>{t("prizes.season.firstPlace.title", "1st Place")}</h3>
              <ul>
                <li>
                  {t(
                    "prizes.season.firstPlace.item1",
                    "Annual subscription to TV2 Play",
                  )}
                </li>
                <li>
                  {t(
                    "prizes.season.firstPlace.item2",
                    "​Signed National Team jersey provided by Norsk Tipping",
                  )}
                </li>
                <li>
                  {t(
                    "prizes.season.firstPlace.item3",
                    "PS5 provided by Altibox",
                  )}
                </li>
                <li>
                  {t(
                    "prizes.season.firstPlace.item4",
                    "Gift card (NOK 7,500) provided by OBOS",
                  )}
                </li>
              </ul>
              <h3>{t("prizes.season.secondPlace.title", "2nd Place")}</h3>
              <ul>
                <li>
                  {t(
                    "prizes.season.secondPlace.item1",
                    "Annual subscription to TV2 Play",
                  )}
                </li>
                <li>
                  {t(
                    "prizes.season.secondPlace.item2",
                    "Signed National Team jersey",
                  )}
                </li>
                <li>
                  {t(
                    "prizes.season.secondPlace.item3",
                    "Gift card (NOK 5,000) provided by OBOS",
                  )}
                </li>
                <li>
                  {t(
                    "prizes.season.secondPlace.item4",
                    "​PS5 provided by Altibox",
                  )}
                </li>
              </ul>
              <h3>{t("prizes.season.thirdPlace.title", "3rd Place")}</h3>
              <ul>
                <li>
                  {t(
                    "prizes.season.thirdPlace.item1",
                    "Annual subscription to TV2 Play",
                  )}
                </li>
                <li>
                  {t(
                    "prizes.season.thirdPlace.item2",
                    "​Gift card (NOK 3,500) provided by OBOS",
                  )}
                </li>
                <li>
                  {t(
                    "prizes.season.thirdPlace.item3",
                    "PS5 provided by Altibox",
                  )}
                </li>
                <li>
                  {t(
                    "prizes.season.thirdPlace.item4",
                    "Signed National Team jersey provided by Norsk Tipping",
                  )}
                </li>
              </ul>
            </Box>
          </Box>
        </Copy>
      </Main>
    </Wrapper>
  );
};

export default Prizes;
